import script from "./IncomeAccountStatementSum.vue?vue&type=script&setup=true&lang=js"
export * from "./IncomeAccountStatementSum.vue?vue&type=script&setup=true&lang=js"

import "./IncomeAccountStatementSum.vue?vue&type=style&index=0&id=4b3de7a8&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b3de7a8"]])

export default __exports__